export const MESSAGE_HIGHLIGHT_QUOTE_EVENT = 'vivport:message-highlight-quote';
export const MESSAGE_OPEN_OBLIGATIONS_EVENT = 'vivport:message-open-obligations';

export interface MessageHighlightQuoteDetail {
  quote: string;
  sourceContentId: number;
}

export function isMessageHighlightQuoteDetail(value: unknown): value is MessageHighlightQuoteDetail {
  if (value === null || typeof value !== 'object') {
    return false;
  }
  const candidate = value as { quote?: unknown; sourceContentId?: unknown };
  return (
    typeof candidate.quote === 'string' &&
    candidate.quote.length > 0 &&
    typeof candidate.sourceContentId === 'number'
  );
}
